import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

// Design-Sprache der neuen Landingpage: Inter (Text), Montserrat (Headlines),
// Night-Ink als Primärfarbe, Lime (#c3f04c) als Akzent.
const HEADING_FONT = '"Montserrat", "Inter", system-ui, sans-serif';
const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#17170f" },
    secondary: { main: "#c3f04c", contrastText: "#14150c" },
    background: { default: "#fff", paper: "#fff" },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontFamily: HEADING_FONT },
    h2: { fontFamily: HEADING_FONT },
    h3: { fontFamily: HEADING_FONT },
    h4: { fontFamily: HEADING_FONT },
    h5: { fontFamily: HEADING_FONT },
    h6: { fontFamily: HEADING_FONT },
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
